export const API = "http://api-sigegob.guarico.gob.ve/api"; // "http://api-sigegob.guarico.gob.ve/api"
export const thumbs =  "http://api-sigegob.guarico.gob.ve/thumbnails/"; //"http://api-sigegob.guarico.gob.ve/thumbnails/";

export const MUNICIPALITY =
  [
    { id: 130, name: "CHAGUARAMAS", isCapital: false },
    { id: 131, name: "EL SOCORRO", isCapital: false },
    { id: 133, name: "LEONARDO INFANTE", isCapital: false },
    { id: 134, name: "LAS MERCEDES", isCapital: false },
    { id: 136, name: "FRANCISCO DE MIRANDA", isCapital: false },
    { id: 143, name: "PEDRO ZARAZA", isCapital: false },
    { id: 138, name: "ORTÍZ", isCapital: false },
    { id: 129, name: "CAMAGUÁN", isCapital: false },
    { id: 132, name: "SAN GERÓNIMO DE GUAYABAL", isCapital: false },
    { id: 135, name: "JULIÁN MELLADO", isCapital: false },
    { id: 137, name: "JOSÉ TADEO MONAGAS", isCapital: false },
    { id: 140, name: "JUAN GERMÁN ROSCIO", isCapital: true },
    { id: 141, name: "SAN JOSÉ DE GUARIBE", isCapital: false },
    { id: 142, name: "SANTA MARÍA DE IPIRE", isCapital: false },
    { id: 139, name: "JOSÉ FÉLIX RIBAS", isCapital: false }
  ];

export const PARISH = [
  {
    id: 453,
    municipality: 142,
    name: "ALTAMIRA",
    intsuperficie: "682590702.0000",
    lng: `65°29'51,2"`,
    lat: `8°35'18"`,
    blncapital: false,
  },
  {
    id: 452,
    municipality: 142,
    name: "SANTA MARÍA DE IPIRE",
    intsuperficie: "3853467264.0000",
    lng: `65°16'26,4"`,
    lat: `8°37'41,2"`,
    blncapital: true,
  },
  {
    id: 451,
    municipality: 141,
    name: "SAN JOSÉ DE GUARIBE",
    intsuperficie: "1149042028.0000",
    lng: `65°50'11,8"`,
    lat: `9°46'54,7"`,
    blncapital: false,
  },
  {
    id: 449,
    municipality: 140,
    name: "CANTAGALLO",
    intsuperficie: "249733851.0000",
    lng: `67°26'27,4"`,
    lat: `9°46'57,5"`,
    blncapital: false,
  },
  {
    id: 450,
    municipality: 140,
    name: "PARAPARA",
    intsuperficie: "998611314.0000",
    lng: `67°10'57"`,
    lat: `9°41'34,3"`,
    blncapital: false,
  },
  {
    id: 448,
    municipality: 140,
    name: "SAN JUAN DE LOS MORROS",
    intsuperficie: "573761536.0000",
    lng: `67°19'54,2"`,
    lat: `9°51'45,9"`,
    blncapital: true,
  },
  {
    id: 435,
    municipality: 137,
    name: "ALTAGRACIA DE ORITUCO",
    intsuperficie: "415001321.0000",
    lng: `66°22'14"`,
    lat: `9°56'11,4"`,
    blncapital: true,
  },
  {
    id: 436,
    municipality: 137,
    name: "LEZAMA",
    intsuperficie: "1102190922.0000",
    lng: `66°22'21,6"`,
    lat: `9°38'37,6"`,
    blncapital: false,
  },
  {
    id: 437,
    municipality: 137,
    name: "LIBERTAD DE ORITUCO",
    intsuperficie: "399887781.0000",
    lng: `66°31'26,1"`,
    lat: `9°26'37,8"`,
    blncapital: false,
  },
  {
    id: 438,
    municipality: 137,
    name: "PASO REAL DE MACAIRA",
    intsuperficie: "434894701.0000",
    lng: `66°5'23,5"`,
    lat: `9°46'25,6"`,
    blncapital: false,
  },
  {
    id: 439,
    municipality: 137,
    name: "SAN FRANCISCO DE MACAIRA",
    intsuperficie: "191723275.0000",
    lng: `66°13'7,7"`,
    lat: `9°54'45,3"`,
    blncapital: false,
  },
  {
    id: 440,
    municipality: 137,
    name: "SAN RAFAEL DE ORITUCO",
    intsuperficie: "619658903.0000",
    lng: `66°24'16,8"`,
    lat: `9°48'23,2"`,
    blncapital: false,
  },
  {
    id: 441,
    municipality: 137,
    name: "SOUBLETTE",
    intsuperficie: "247203078.0000",
    lng: `66°3'48,3"`,
    lat: `9°54'17,1"`,
    blncapital: false,
  },
  {
    id: 429,
    municipality: 135,
    name: "EL SOMBRERO",
    intsuperficie: "1579785892.0000",
    lng: `66°58'53,6"`,
    lat: `9°18'59,4"`,
    blncapital: true,
  },
  {
    id: 430,
    municipality: 135,
    name: "SOSA",
    intsuperficie: "512491210.0000",
    lng: `67°11'10,3"`,
    lat: `9°16'1,5"`,
    blncapital: false,
  },
  {
    id: 423,
    municipality: 132,
    name: "CAZORLA",
    intsuperficie: "2178372708.0000",
    lng: `66°50'2,9"`,
    lat: `7°51'35"`,
    blncapital: false,
  },
  {
    id: 422,
    municipality: 132,
    name: "SAN GERÓNIMO DE GUAYABAL",
    intsuperficie: "1854860206.0000",
    lng: `67°15'32,9"`,
    lat: `8°3'32,3"`,
    blncapital: true,
  },
  {
    id: 417,
    municipality: 129,
    name: "CAMAGUÁN",
    intsuperficie: "1009667376.0000",
    lng: `67°37'1,3"`,
    lat: `8°5'23,4"`,
    blncapital: true,
  },
  {
    id: 418,
    municipality: 129,
    name: "PUERTO MIRANDA",
    intsuperficie: "188550818.0000",
    lng: `67°27'27,9"`,
    lat: `7°57'1,7"`,
    blncapital: false,
  },
  {
    id: 419,
    municipality: 129,
    name: "UVERITO",
    intsuperficie: "218628991.0000",
    lng: `67°28'16,6"`,
    lat: `8°4'10"`,
    blncapital: false,
  },
  {
    id: 442,
    municipality: 138,
    name: "ORTIZ",
    intsuperficie: "1001991222.0000",
    lng: `67°21'17,1"`,
    lat: `9°23'30,3"`,
    blncapital: true,
  },
  {
    id: 443,
    municipality: 138,
    name: "SAN FRANCISCO DE TIZNADOS",
    intsuperficie: "1447850183.0000",
    lng: `67°42'39,4"`,
    lat: `9°32'55,8"`,
    blncapital: false,
  },
  {
    id: 444,
    municipality: 138,
    name: "SAN JOSÉ DE TIZNADOS",
    intsuperficie: "1050325805.0000",
    lng: `67°37'51,2"`,
    lat: `9°19'45,7"`,
    blncapital: false,
  },
  {
    id: 445,
    municipality: 138,
    name: "SAN LORENZO DE TIZNADOS",
    intsuperficie: "605513921.0000",
    lng: `67°39'56,4"`,
    lat: `9°45'18,6"`,
    blncapital: false,
  },
  {
    id: 455,
    municipality: 143,
    name: "SAN JOSÉ DE UNARE",
    intsuperficie: "242831904.0000",
    lng: `65°21'29,3"`,
    lat: `9°30'53,4"`,
    blncapital: false,
  },
  {
    id: 454,
    municipality: 143,
    name: "ZARAZA",
    intsuperficie: "2816691075.0000",
    lng: `65°12'22,8"`,
    lat: `9°3'53,3"`,
    blncapital: true,
  },
  {
    id: 431,
    municipality: 136,
    name: "CALABOZO",
    intsuperficie: "5952241315.0000",
    lng: `67°20'53,2"`,
    lat: `8°45'5,2"`,
    blncapital: true,
  },
  {
    id: 432,
    municipality: 136,
    name: "EL CALVARIO",
    intsuperficie: "4994466361.0000",
    lng: `66°55'47,5"`,
    lat: `8°43'45,9"`,
    blncapital: false,
  },
  {
    id: 433,
    municipality: 136,
    name: "EL RASTRO",
    intsuperficie: "422336809.0000",
    lng: `67°29'33,5"`,
    lat: `9°5'57,7"`,
    blncapital: false,
  },
  {
    id: 434,
    municipality: 136,
    name: "GUARDATINAJAS",
    intsuperficie: "2578681292.0000",
    lng: `67°46'7,4"`,
    lat: `8°54'35"`,
    blncapital: false,
  },
  {
    id: 427,
    municipality: 134,
    name: "CABRUTA",
    intsuperficie: "2369126372.0000",
    lng: `66°27'10,1"`,
    lat: `7°53'42,7"`,
    blncapital: false,
  },
  {
    id: 426,
    municipality: 134,
    name: "LAS MERCEDES",
    intsuperficie: "2433941469.0000",
    lng: `66°28'47,2"`,
    lat: `8°54'46,4"`,
    blncapital: true,
  },
  {
    id: 428,
    municipality: 134,
    name: "SANTA RITA DE MANAPIRE",
    intsuperficie: "3196542636.0000",
    lng: `66°28'56,3"`,
    lat: `8°22'2"`,
    blncapital: false,
  },
  {
    id: 425,
    municipality: 133,
    name: "ESPINO",
    intsuperficie: "7716266060.0000",
    lng: `65°57'18,6"`,
    lat: `8°18'35"`,
    blncapital: false,
  },
  {
    id: 424,
    municipality: 133,
    name: "VALLE DE LA PASCUA",
    intsuperficie: "2372562798.0000",
    lng: `66°5'52,3"`,
    lat: `9°7'57,9"`,
    blncapital: true,
  },
  {
    id: 420,
    municipality: 130,
    name: "CHAGUARAMAS",
    intsuperficie: "2290352294.0000",
    lng: `66°21'28,9"`,
    lat: `9°19'41,1"`,
    blncapital: false,
  },
  {
    id: 421,
    municipality: 131,
    name: "EL SOCORRO",
    intsuperficie: "2658835892.0000",
    lng: `65°32'47,4"`,
    lat: `8°16'8,1"`,
    blncapital: false,
  },
  {
    id: 447,
    municipality: 139,
    name: "SAN RAFAEL DE LAYA",
    intsuperficie: "395841301.0000",
    lng: `65°40'6,2"`,
    lat: `9°33'7,6"`,
    blncapital: false,
  },
  {
    id: 446,
    municipality: 139,
    name: "TUCUPIDO",
    intsuperficie: "1870339671.0000",
    lng: `65°45'11,4"`,
    lat: `9°18'36,7"`,
    blncapital: true,
  }
];

export const LOGO =
  'data:image/png;base64,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';